/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'dash-gis-file-delete-confirm',
    templateUrl: './file-delete-confirm.component.html',
    styleUrls: [ './file-delete-confirm.component.scss' ]
})
export class FileDeleteConfirmComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<FileDeleteConfirmComponent>,
    ) { }

    ngOnInit(): void {}

    cancel() {
        this.dialogRef.close(false);
    }
}
